<div class="card">
    <div class="card-body">
        <h3>
            {{ strings.title }} {{ strings.count }}
            <span
                *ngIf="strings.count !== '(0)' && !showParticipantList && notification.csmlTrackerUrl"
                class="pace-link-font"
                paceCoreLink
            >
                <a
                    class="pace-link"
                    href="{{ notification.csmlTrackerUrl }}"
                    target="_blank"
                    translate="TRACK_ALL_ORDERS"
                >
                </a>
            </span>
        </h3>
        <carousel #carousel [noWrap]="true" [showIndicators]="false" interval="0">
            <slide class="no-records" *ngIf="slides.length === 0">
                <span translate="NOTIFICATION_DETAILS_NO_RECORDS_AVAILABLE_TITLE"></span>
            </slide>

            <slide paceSwipe *ngFor="let slide of slides" (swipeLeft)="swipe($event)" (swipeRight)="swipe($event)">
                <div class="row flex-nowrap mx-2 my-1">
                    <div class="material-participants-section col d-flex flex-column px-0" *ngFor="let column of slide">
                        <!--Materials -->
                        <ng-container *ngIf="!showParticipantList; else participantContainer">
                            <ng-container
                                *ngTemplateOutlet="materialList; context: { $implicit: column }"
                            ></ng-container
                        ></ng-container>
                        <!--Participants -->
                        <ng-template #participantContainer>
                            <ng-container
                                *ngTemplateOutlet="participantList; context: { $implicit: column }"
                            ></ng-container>
                        </ng-template>
                    </div>
                </div>
            </slide>
            <div class="carousel-indicators">
                <button
                    *ngFor="let slide of slides; let i = index"
                    type="button"
                    aria-current="true"
                    [class.active]="i === carousel.activeSlide"
                    data-bs-target="#carousel1"
                    [attr.aria-label]="('NOTIFICATION_DETAILS_CAROUSEL_BUTTON_LABEL' | translate) + (i + 1)"
                    (click)="carousel.selectSlide(i)"
                ></button>
            </div>
        </carousel>
    </div>
    <!-- card-body -->
</div>
<!-- panel -->

<ng-template #materialList let-column>
    <ul *ngFor="let item of column">
        <li class="user-select-auto horizontal-icons-list">
            {{ item.materialIdentifier.orderNumber.value }} | {{ item.materialIdentifier.orderPosition.value }} |
            {{ item.deliveredQuantity }} {{ item.quantityUnit.value }}
            <fa-icon *ngIf="item.showDangerousInfo" [icon]="faExclamationTriangle"></fa-icon>
            <fa-icon *ngIf="item.isPurchaseOrderTaxiBillable" [icon]="faTaxi"></fa-icon>
            <fa-icon *ngIf="item.isQualityPart" [icon]="faSearch"></fa-icon>
            <fa-icon *ngIf="item.isRentalTool" [icon]="faWrench"></fa-icon>
        </li>
        <li *ngIf="item.csmlTrackerUrl" paceCoreLink>
            <a href="{{ item.csmlTrackerUrl }}" class="pace-link" target="_blank" translate="TRACK_ORDER"></a>
        </li>
        <li class="user-select-auto" *ngIf="displayBatchId && item.batchNumber.value">{{ item.batchNumber.value }}</li>
        <li class="user-select-auto">
            {{ item.description.value }}
            <span *ngIf="item.smartSensorTrackerUrl.length > 0" paceCoreLink>
                <a
                    href="{{ item.smartSensorTrackerUrl }}{{ item.materialIdentifier.orderNumber.value }}"
                    class="pace-link"
                    target="_blank"
                    [attr.aria-label]="'NOTIFICATION_DETAILS_LINK_TO_SMART_SENSOR_TRACKER_LABEL' | translate"
                    ><fa-icon [icon]="faExternalLinkSquareAlt"></fa-icon></a
            ></span>
        </li>
        <li>
            <span class="user-select-auto" *ngIf="sparePartCatalogMatLink" paceCoreLink>
                {{ item.materialIdentifier.materialNumber.value }}
                <a
                    class="pace-link"
                    target="_blank"
                    href="{{ sparePartCatalogMatLink }}matnum={{ mainEquipmentMatNumber }}&partnum={{
                        item.materialIdentifier.materialNumber.value
                    }}"
                    [attr.aria-label]="'NOTIFICATION_DETAILS_LINK_TO_SPARE_PARTS_CATALOG_LABEL' | translate"
                >
                    <fa-icon [icon]="faExternalLinkSquareAlt"></fa-icon>
                </a>
            </span>
            <span *ngIf="!sparePartCatalogMatLink">({{ item.materialIdentifier.materialNumber.value }})</span>
        </li>
        <li *ngIf="!getMaterialPickedUpQuantity(item)" class="d-flex align-items-center">
            <span> <fa-icon [icon]="faInfoCircle"></fa-icon>&nbsp; </span>
            <button
                *ngIf="!item.materialStatus.isNotReceived"
                class="btn btn-link ps-0"
                (click)="openPickupModal(item)"
            >
                <span translate="NOTIFICATION_DETAILS_MATERIAL_PICKUP_LABEL"></span>
            </button>
            <span
                *ngIf="item.materialStatus.isNotReceived"
                class="text-muted"
                translate="NOTIFICATION_DETAILS_MATERIAL_NOT_RECEIVED_LABEL"
            ></span>
        </li>
        <li *ngIf="getMaterialPickedUpQuantity(item)">
            {{ getMaterialPickedUpQuantity(item) }}
            <span translate="MATERIAL_PICKUP_PICKED_STATUS"></span>
        </li>
    </ul>
</ng-template>

<ng-template #participantList let-column>
    <ul *ngFor="let item of column">
        <li>
            {{ item.lastName.value }}
            <span *ngIf="item.lastName.value && item.firstName.value">,</span>
            {{ item.firstName.value }}
        </li>
        <li>
            <a (click)="openEmail(item.mail.value)">{{ item.mail.value }}</a>
        </li>
    </ul>
</ng-template>
